import React, {useState, useEffect} from "react";
import axios from "axios";
import "./PopupLogin.css";
import herb from "./herb.png";
import {useNavigate} from "react-router-dom";
import {useRef} from "react";
import ConditionPopup from "../conditionPopup/ConditionPopup";
import {useFormik} from "formik";
import * as yup from "yup";
import { v4 as uuidv4 } from 'uuid';
import {useLocation} from "react-router-dom";
import {IoArrowBack} from "react-icons/io5";
import {
    AiFillEye,
    AiFillEyeInvisible,
    AiOutlineCheckCircle, AiOutlineClose,
} from "react-icons/ai";
import CustomAlert from "../ConfirmationModal/CustomAlert";
import {Button, CircularProgress, Tooltip, Checkbox} from "@mui/material";
import {MdCheckCircle, MdOutlineVerified} from "react-icons/md";
import DatePicker from "react-datepicker";
import {ka} from "date-fns/locale";

const PopupLogin = ({isOpened, onClose}) => {
    const location = useLocation();
    const [UserName, setUsername] = useState("");
    const [forgotEmail, setForgotEmail] = useState("");
    const [forgotEmailError, setForgotEmailError] = useState("");
    const [forgotEmailSuccess, setForgotEmailSuccess] = useState(false);
    const [Password, setPassword] = useState("");
    const [showLoginPage, setShowLoginPage] = useState(true);
    const [showRegistration, setShowRegistration] = useState(false);
    const [showForgotPassword, setShowForgotPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingOrgData, setLoadingOrgData] = useState(false);
    const [isUserDataLoading, setIsUserDataIsLoading] = useState(false);
    const loginButtonRef = useRef(null);
    const [loginButtonDisabled, setLoginButtonDisabled] = useState(false);
    const navigate = useNavigate();
    const [isConditionPopupOpen, setIsConditionPopupOpen] = useState(false);
    const [animation, setAnimation] = useState("open");
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [alert, setAlert] = useState({message: "", type: "", show: false});
    const [isLegalEntity, setIsLegalEntity] = useState(false);
    const [passwordVisibleReg, setPasswordVisibleReg] = useState(false);
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
    const [isOrgVerified, setIsOrgVerified] = useState(false);
    const [isUserVerified, setIsUserVerified] = useState(false);
    const [userPrivateNumber, setUserPrivateNumber] = useState('');
    const [orgPrivateNumber, setOrgPrivateNumber] = useState('');
    const [userSurname, setUserSurname] = useState('');
    const [orgSurname, setOrgSurname] = useState('');
    const [orgName, setOrgName] = useState("");
    const [userFirstName, setUserFirstName] = useState("");
    const [orgFirstName, setOrgFirstName] = useState("");
    const [canOrgRegister, setCanOrgRegister] = useState(false);
    const [orgNumber, setOrgNumber] = useState("");
    const [userIp, setUserIp] = useState('124124');
    const isMobile = window.innerWidth < 768;


    useEffect(() => {
        if (isOrgVerified) {
            setCanOrgRegister(true)
        } else {
            setCanOrgRegister(false)
        }
    }, [isOrgVerified]);


    const verifyOrgNumber = async (orgNumber) => {
        setLoadingOrgData(true);
        setAlert({
            message: "",
            type: "error",
            show: false,
        });
        try {


            const response = await axios.get(
                `https://tcsa.gov.ge/api/NAPR_ENREGWS_GetSubjByIdNrQuery?identificationNumber=${orgNumber}&SettingEndpointKeyWord=GetSubjByIdNrQuery&ipAddress=${userIp}`
            );
            if (response.data && response.data.success) {
                const orgData = response.data.data;
                if (orgData && orgData.name) {
                    setOrgName(orgData.name);
                    setIsOrgVerified(true);
                } else {
                    setAlert({
                        message: "ორგანიზაციის საიდენთიფიკაციო კოდი არასწორია",
                        type: "error",
                        show: true,
                    });
                    setIsOrgVerified(false);
                }
            } else if (response.data.success === false) {
                setAlert({
                    message: response.data.errors[0]?.message || 'An unknown error occurred',
                    severity: 'error',
                    show: true,
                });
            } else {
                setAlert({
                    message: "ორგანიზაციის საიდენთიფიკაციო კოდი არასწორია",
                    type: "error",
                    show: true,
                });
                setIsOrgVerified(false);
            }
        } catch (error) {
            setAlert({
                message: "ორგანიზაციის საიდენთიფიკაციო კოდი არასწორია",
                type: "error",
                show: true,
            });
            setIsOrgVerified(false);
        } finally {
            setLoadingOrgData(false);
        }
    };


    const verifyPrivateNumber = async () => {
        setIsUserDataIsLoading(true)
        setAlert({
            message: "",
            type: "error",
            show: false,
        });
        try {

            const response = await axios.get(
                `https://tcsa.gov.ge/api/GetPhisicalPersonInfo?PrivateNumber=${userPrivateNumber}&LastName=${userSurname}&SettingEndpointKeyWord=GetPhisicalPersonInfo&ipAddress=${userIp}`
            );
            if (response.data && response.data.success) {
                const userData = response.data.data;
                if (userData && userData.firstName) {
                    setUserFirstName(userData.firstName);
                    setIsUserVerified(true);
                } else {
                    setAlert({
                        message: "პირადი ნომერი ან გვარი არასწორია!",
                        type: "error",
                        show: true,
                    });
                    setIsUserVerified(false);
                }
            } else {
                setAlert({
                    message: "პირადი ნომერი ან გვარი არასწორია!",
                    type: "error",
                    show: true,
                });
                setIsUserVerified(false);
            }
        } catch (error) {
            setAlert({
                message: "დაფიქრიდა შეცოდმა",
                type: "error",
                show: true,
            });
            setIsUserVerified(false);
        } finally {
            setIsUserDataIsLoading(false);
        }
    };


    useEffect(() => {
        if (showLoginPage) {
            loginButtonRef.current.focus();
        }
    }, [showLoginPage]);
    const toggleConditionPopup = () => {
        setIsConditionPopupOpen(!isConditionPopupOpen);
    };

    const jwtDecode = (token) => {
        try {
            const base64Url = token.split(".")[1];
            const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
            const jsonPayload = decodeURIComponent(
                atob(base64)
                    .split("")
                    .map(function (c) {
                        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
                    })
                    .join("")
            );

            return JSON.parse(jsonPayload);
        } catch (e) {
            return null;
        }
    };

    const handleLogin = async () => {

        try {
            setLoading(true);
            const params = new URLSearchParams({
                Email: UserName,
                Password: Password,
            });

            const apiUrl = process.env.REACT_APP_API_BASE_URL + "/User/Login";

            const response = await axios.get(`${apiUrl}?${params.toString()}`);

            if (response.status === 200 && response.data.success) {
                const token = response.data.data.token;
                const ExpiredTime = response.data.data.expirtaion;
                localStorage.setItem("jwtToken", token);
                localStorage.setItem("jwtTokenMain", token);
                localStorage.setItem("tokenExpiredTime", ExpiredTime);

                const decodedToken = jwtDecode(token);
                const userRole = decodedToken.role;

                try {
                    if (userRole && userRole !== "USER" && userRole !== "ROOTADMIN") {
                        const usersResponse = await axios.get(
                            `${process.env.REACT_APP_API_BASE_URL}/GetMyTemporaryUsers`
                        );

                        if (usersResponse.status === 200 && usersResponse.data.success) {
                            const temporaryUsers = usersResponse.data.data;

                            for (let index = 0; index < temporaryUsers.length; index++) {
                                const user = temporaryUsers[index];
                                const tempParams = new URLSearchParams({
                                    Email: user.onVacationUserEmail,
                                    Password: Password,
                                });

                                const tempLoginResponse = await axios.get(
                                    `${apiUrl}?${tempParams.toString()}`
                                );

                                if (
                                    tempLoginResponse.status === 200 &&
                                    tempLoginResponse.data.success
                                ) {
                                    const tempToken = tempLoginResponse.data.data.token;
                                    localStorage.setItem(`${index + 1}_jwtToken`, tempToken);
                                } else {
                                }
                            }
                        }
                    }
                } catch (error) {
                }

                if (userRole === "USER") {
                    navigate("/dashboard/home");
                } else if (userRole === "ROOTADMIN") {
                    navigate("/dashboard/pagemanager");
                } else {
                    navigate("/dashboard/home");
                }
            } else {
                setAlert({
                    message: response.data.errors
                        ? response.data.errors[0].message
                        : "დაფიქსრიდა შეცდომა, ცადეთ მოგვიანებით",
                    type: "error",
                    show: true,
                });
            }
        } catch (error) {
            setAlert({
                message: "დაფიქსრიდა შეცდომა, ცადეთ მოგვიანებით",
                type: "error",
                show: true,
            });
        } finally {
            setLoading(false);
            setLoginButtonDisabled(false);
        }
    };

    const validateForgotEmail = () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(forgotEmail)) {
            setForgotEmailError("არასწორი ფორმატი");
            return false;
        }
        setForgotEmailError(""); // Clear any previous errors
        return true;
    };

    const registrationValidationSchema = yup.object({
        Password: yup
            .string()
            .required("გთხოვთ, შეიყვანოთ პაროლი")
            .min(6, "პაროლი უნდა შეიცავდეს მინიმუმ 6 სიმბოლოს")
            .matches(
                /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])/,
                "პაროლი უნდა შეიცავდეს ციფრს, დიდ ასოს და პატარა ასოს"
            ),
        ConfirmPassword: yup
            .string()
            .oneOf([yup.ref("Password"), null], "პაროლები უნდა ემთხვეოდეს")
            .required("გთხოვთ განმეორებით შეიყვანოთ პაროლი"),

        Email: yup
            .string()
            .email("არასწორი ფორმატი")
            .required("გთხოვთ, შეიყვანოთ ელ-ფოსტა"),
        Phone: yup.string().required("გთხოვთ შეიყვანოთ ნომერი"),
        termsAccepted: yup
            .boolean()
            .oneOf([true], "რეგისტრაციისთვის დაეთანხმეთ პირობებს"),
        birthDate: isLegalEntity
            ? yup.mixed().notRequired()
            : yup.date()
                .required("გთხოვთ, შეიყვანოთ დაბადების თარიღი")
                .max(
                    new Date(new Date().getFullYear() - 18, new Date().getMonth(), new Date().getDate()),
                    "რეგისტრაციისთვის უნდა იყოთ 18 წლის!"
                )

    });

    useEffect(() => {
        const handleEscape = (event) => {
            if (event.key === "Escape") {
                onClose();
            }
        };

        // Add event listener
        window.addEventListener("keydown", handleEscape);

        // Remove event listener on cleanup
        return () => window.removeEventListener("keydown", handleEscape);
    }, [onClose]);


    useEffect(() => {
        if (isOpened) {
            setAnimation("open");
        }
    }, [isOpened]);

    const formik = useFormik({
        initialValues: {
            UserName: "",
            Password: "",
            ConfirmPassword: "",
            PersonalNumber: "",
            FirstName: "",
            LastName: "",
            Email: "",
            Phone: "",
            Mobile: "",
            termsAccepted: false,
            birthDate: "",


        },
        validationSchema: registrationValidationSchema,

        onSubmit: async (values) => {
            const formattedBirthDate = values.birthDate
                ? values.birthDate.toISOString().split('T')[0]
                : '2030-01-01';

            try {
                const response = await axios.post(
                    `${process.env.REACT_APP_API_BASE_URL}/User/Registration`,
                    {
                        username: values.Email,
                        password: values.Password,
                        email: values.Email,
                        pNumber: !isLegalEntity && userPrivateNumber ? userPrivateNumber : isLegalEntity  ? uuidv4() : "1231",
                        firstName: !isLegalEntity && userFirstName ? userFirstName : isLegalEntity && orgFirstName ? orgFirstName : " ",
                        lastName: !isLegalEntity && userSurname ? userSurname : isLegalEntity && orgSurname ? orgSurname : " ",
                        phone: values.Phone,
                        isOorganisation: isLegalEntity,
                        orgNumber: isLegalEntity && orgNumber ? orgNumber : "",
                        orgName: isLegalEntity && orgName ? orgName : "",
                        birthDate: formattedBirthDate,
                    }
                );

                if (response.status === 200) {
                    if (response.data.success) {
                        setAlert({
                            message:
                                "ოპერაცია წარმატებით დასრულდა! ანგარიშის გააქტიურებისთვის შეამოწმეთ ელ-ფოსტა და მიყევით ინსტრუქციას!",
                            type: "success",
                            show: true,
                        });
                        formik.resetForm();
                        handleLoginClick();
                        setUserSurname('')
                        setOrgPrivateNumber("")
                        setOrgSurname("")
                        setUserPrivateNumber('')
                        setOrgNumber('')
                        setOrgName('')
                        setIsUserVerified(false)

                    } else {
                        setAlert({
                            message: response.data.errorMessage || "დაფიქრისდა შეცდომა",
                            type: "error",
                            show: true,
                        });
                    }
                } else {
                    setAlert({
                        message: "დაფიქსრიდა შეცდომა, ცადეთ მოგვიანებით",
                        type: "error",
                        show: true,
                    });
                }
            } catch (error) {
                setAlert({
                    message: error.message || "დაფიქსრიდა შეცდომა, ცადეთ მოგვიანებით",
                    type: "error",
                    show: true,
                });
            }
        },
    });

    const handleClose = () => {
        setAnimation("close");
        if (
            location.pathname.includes("interactivemap") ||
            location.pathname.includes("map")
        ) {
            onClose();
        } else {
            setTimeout(() => {
                onClose();
            }, 500);
        }
    };

    const handleBackLegal = () => {
        setIsOrgVerified(false);
        setCanOrgRegister(false)
        setOrgPrivateNumber("")
        setOrgSurname("")
        setOrgName("");
        setOrgNumber("");
        formik.resetForm();
    };

    const handleBackPersonal = () => {
        setIsUserVerified(false);
        setUserPrivateNumber('')
        setUserSurname('')
        formik.resetForm();
    };


    const handlePrivateEntity = () => {
        setIsLegalEntity(false);
        setIsOrgVerified(false)
        setCanOrgRegister(false)
        setOrgNumber('')
        setOrgPrivateNumber("")
        setOrgSurname("")
        setOrgName('')
        formik.resetForm();
    };
    const handleLegalEntity = () => {
        setIsUserVerified(false)
        setUserPrivateNumber('')
        setUserSurname('')
        setIsLegalEntity(true);
        formik.resetForm();
    };

    const handleLoginClick = () => {
        setShowLoginPage(true);
        setShowRegistration(false);
        setShowForgotPassword(false);
        setLoginButtonDisabled(false);
        formik.resetForm();
    };

    const handleRegistrationClick = () => {
        setShowLoginPage(false);
        setShowRegistration(true);
        setShowForgotPassword(false);
        setLoginButtonDisabled(false);
        formik.resetForm();
    };

    const handleForgotPasswordClick = () => {
        setShowLoginPage(false);
        setShowRegistration(false);
        setShowForgotPassword(true);
        formik.resetForm();
        setLoginButtonDisabled(false);
    };

    const handleForgotPasswordSubmit = async () => {
        if (!validateForgotEmail()) {
            setForgotEmailError("არასწორი ფორმატი");
            return;
        }

        try {
            // Prepare the request body
            const requestBody = {
                email: forgotEmail,
            };

            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/User/ForgetPassword`,
                requestBody
            );

            if (response.status === 200 && response.data.success) {
                setForgotEmail(""); // Optionally clear the input
                setForgotEmailSuccess(true);
            } else {
                setForgotEmailError("ელ-ფოსტა არ მოიძებნა!");
                setForgotEmailSuccess(false);
            }
        } catch (error) {
            if (error.response) {
            } else if (error.request) {
            } else {
            }
        }
    };

    return (
        isOpened && (
            <div className={`popup-container ${animation}`}>
                {showLoginPage && (
                    <div className={`popup-container `}>
                        <div className="popup-login">
                            <AiOutlineClose
                                className="popup-exit-icon"
                                onClick={handleClose}
                            />
                            <div>
                                <img src={herb} alt="Logo" className="popup-logo"/>
                                <h1 className="popup-title">{"შესვლა"}</h1>
                                <p className="popup-subtitle">{"სააგენტოს ციფრული პორტალი"}</p>
                                <p className="popup-text-block">{"შეიყვანე მონაცემები"}</p>

                                {loading ? (
                                    <div className={"center-loader"}>
                                        <CircularProgress color="inherit"/>
                                    </div>
                                ) : (
                                    <>
                                        <input
                                            type="text"
                                            className="popup-input"
                                            placeholder={"ელ-ფოსტა"}
                                            value={UserName}
                                            onChange={(e) => setUsername(e.target.value)}
                                            onKeyDown={(e) => e.key === "Enter" && handleLogin()}
                                        />
                                        <div className="password-input-container">
                                            <input
                                                type={passwordVisible ? "text" : "password"}
                                                className="popup-input-passworf"
                                                placeholder={"პაროლი"}
                                                value={Password}
                                                onChange={(e) => setPassword(e.target.value)}
                                            />
                                            <button
                                                onClick={() => setPasswordVisible(!passwordVisible)}
                                                className="toggle-password-visibility"
                                            >
                                                {passwordVisible ? (
                                                    <AiFillEyeInvisible
                                                        className={"slide-in-input"}
                                                        style={{fontSize: "26px", color: "#2A2A2A"}}
                                                    />
                                                ) : (
                                                    <AiFillEye
                                                        className={"slide-in-input"}
                                                        style={{fontSize: "26px", color: "#2A2A2A"}}
                                                    />
                                                )}
                                            </button>
                                        </div>
                                    </>
                                )}

                                <Tooltip
                                    title={
                                        Password === "" || UserName === ""
                                            ? "ავტორიზაციისთვის შეიყვანეთ ელ-ფოსტა და პაროლი!"
                                            : ""
                                    }
                                >
                                    <div>
                                        <button
                                            className="popup-login-button"
                                            onClick={handleLogin}
                                            disabled={
                                                loading ||
                                                loginButtonDisabled ||
                                                Password === "" ||
                                                UserName === ""
                                            }
                                            ref={loginButtonRef}
                                        >
                                            {loading
                                                ? "მიმდინარეობს ავტორიზაცია..."
                                                : "პორტალში შესვლა"}
                                        </button>
                                    </div>

                                </Tooltip>
                                <div className="popup-bottom-text">
                                    <button
                                        className="popup-forgot-password"
                                        onClick={handleForgotPasswordClick}
                                    >
                                        {"დაგავიწყდა პაროლი?"}
                                    </button>
                                    <button
                                        className="popup-registration"
                                        onClick={handleRegistrationClick}
                                    >
                                        {"რეგისტრაცია"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {showRegistration && (
                    <div className={`popup-container`}>

                            {!isLegalEntity ? (
                                <div className={isUserVerified ? "popup-forget" : "popup-legal"}>
                                    <AiOutlineClose
                                        className="popup-exit-icon"
                                        onClick={handleClose}
                                    />
                                    <div>
                                        <img src={herb} alt="Logo" className="popup-logo"/>
                                        <h1 className="popup-title">{"რეგისტრაცია"}</h1>
                                        <p className="popup-subtitle">
                                            {"სააგენტოს ციფრული პორტალი"}
                                        </p>
                                        <div className={"popup-login-switcher"}>
                                            <button
                                                className={`popup-text-blockk ${
                                                    !isLegalEntity ? "active" : ""
                                                }`}
                                                onClick={handlePrivateEntity}
                                            >
                                                {"ფიზიკური პირი"}
                                            </button>
                                            <button
                                                className={`popup-text-blockk ${
                                                    isLegalEntity ? "active" : ""
                                                }`}
                                                onClick={handleLegalEntity}
                                            >
                                                {"იურიდიული პირი"}
                                            </button>
                                        </div>
                                        {isUserDataLoading ? (
                                            <div>
                                                <div style={{
                                                    textAlign: 'center',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    marginTop: "20%"
                                                }}>
                                                    +
                                                    <MdOutlineVerified style={{fontSize: 80, color: 'black'}}
                                                                       className={"pulse-element"}/>
                                                    <h1>გთხოვთ დაელოდოთ...</h1>
                                                    <p>მიმდინარეობს მონაცემების ვერიფიკაცია!</p>
                                                </div>
                                            </div>
                                        ) : !isUserVerified ? (
                                                <div style={{margin: "20px"}}>
                                                    <div style={{marginBottom: "20px", width: '100%'}}>
                                                        <input
                                                            className={"popup-input-animation"}
                                                            placeholder={"პირადი ნომერი"}
                                                            value={userPrivateNumber}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                if (/^\d*$/.test(value)) {
                                                                    setUserPrivateNumber(value);
                                                                }
                                                            }}
                                                        />
                                                        <div className={"error-text-animation"}>
                                                            {userPrivateNumber !== "" && userPrivateNumber.length !== 11
                                                                ? "პირადი ნომერი უნდა შეიცავდეს 11 სიმბოლოს!"
                                                                : ""}
                                                        </div>

                                                    </div>

                                                    <div style={{marginBottom: "20px", width: '100%'}}>
                                                        <input
                                                            placeholder={"გვარი"}
                                                            value={userSurname}
                                                            onChange={(e) => setUserSurname(e.target.value)}
                                                            className={"popup-input-animation"}
                                                        />
                                                        {
                                                            userSurname !== "" && !/^[\u10A0-\u10FF]+$/.test(userSurname) && (
                                                                <div className={"error-text-animation"}>
                                                                    გვარი უნდა შეიცავდეს მხოლოდ ქართულ ასოებს!
                                                                </div>
                                                            )
                                                        }
                                                    </div>

                                                    <Tooltip
                                                        title={
                                                            userPrivateNumber === ""
                                                                ? "გთხოვთ შეიყვანოთ პირადი ნომერი!"
                                                                : userPrivateNumber.length !== 11
                                                                    ? "პირადი ნომერი უნდა შეიცავდეს 11 სიმბოლოს!"
                                                                    : !/^\d+$/.test(userPrivateNumber)
                                                                        ? "პირადი ნომერი უნდა შეიცავდეს მხოლოდ ციფრებს!"
                                                                        : userSurname === ""
                                                                            ? "გთხოვთ შეიყვანოთ გვარი"
                                                                            : !/^[\u10A0-\u10FF]+$/.test(userSurname)
                                                                                ? "გვარი უნდა შეიცავდეს მხოლოდ ქართულ ასოებს!"
                                                                                : ""
                                                        }
                                                    >
                                                    <span>
                                                        <Button
                                                            onClick={verifyPrivateNumber}
                                                            disabled={
                                                                userPrivateNumber === "" ||
                                                                userPrivateNumber.length !== 11 ||
                                                                !/^\d+$/.test(userPrivateNumber) ||
                                                                userSurname === "" || !/^[\u10A0-\u10FF]+$/.test(userSurname)
                                                            }
                                                            variant="contained"
                                                            color="primary"
                                                            className={"slide-in-input"}
                                                            endIcon={<MdCheckCircle/>}
                                                            style={{textTransform: "none"}}
                                                        >
                                                            ვერიფიკაცია
                                                        </Button>
                                                    </span>
                                                    </Tooltip>
                                                </div>


                                            ) :
                                            (<form autoComplete="off" onSubmit={formik.handleSubmit}>
                                                <button
                                                    className="legal-back-button"
                                                    onClick={handleBackPersonal}
                                                >
                                                    <IoArrowBack style={{marginRight: "8px"}}/> უკან
                                                    დაბრუნება
                                                </button>
                                                <div className={"popup-registrtation-form"}>
                                                    <div className="input-container">
                                                        <input
                                                            type="email"
                                                            name="Email"
                                                            placeholder={"ელ-ფოსტა"}
                                                            className={`popup-input-registration ${
                                                                formik.touched.Email && formik.errors.Email ? "input-error" : ""
                                                            }`}
                                                            onFocus={(e) => e.target.removeAttribute('readonly')} // Remove readonly on focus
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.Email}
                                                        />
                                                        {formik.touched.Email && formik.errors.Email && (
                                                            <div className="error-message-reg">
                                                                {formik.errors.Email}
                                                            </div>
                                                        )}
                                                    </div>
                                                    {isUserVerified && userPrivateNumber && (
                                                        <div style={{cursor: "not-allowed"}}>
                                                            <Tooltip title={userPrivateNumber}>
                                                                <div className="input-container">
                                                                    <input
                                                                        type="text"
                                                                        name="userPrivateNumber"
                                                                        placeholder="პირადი ნომერი"
                                                                        value={userPrivateNumber}
                                                                        readOnly
                                                                        className="popup-input-registration-disabled"
                                                                    />
                                                                </div>
                                                            </Tooltip>
                                                        </div>
                                                    )}


                                                    <div className="input-container">
                                                        <input
                                                            type={passwordVisibleReg ? "text" : "password"}
                                                            name="Password"
                                                            placeholder="პაროლი"
                                                            className={`popup-input-registration ${
                                                                formik.touched.Password && formik.errors.Password ? "input-error" : ""
                                                            }`}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.Password}
                                                            autoComplete="new-password"
                                                        />
                                                        <button
                                                            type="button"
                                                            onClick={() =>
                                                                setPasswordVisibleReg(!passwordVisibleReg)
                                                            }
                                                            className="toggle-password-visibility-reg"
                                                        >
                                                            {passwordVisibleReg ? (
                                                                <AiFillEyeInvisible
                                                                    style={{fontSize: "20px", color: "black"}}
                                                                />
                                                            ) : (
                                                                <AiFillEye
                                                                    style={{fontSize: "20px", color: "black"}}
                                                                />
                                                            )}
                                                        </button>
                                                        {formik.touched.Password && formik.errors.Password && (
                                                            <div className="error-message-reg">
                                                                {formik.errors.Password}
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className="input-container">
                                                        <input
                                                            type={confirmPasswordVisible ? "text" : "password"}
                                                            name="ConfirmPassword"
                                                            placeholder={"გაიმეორეთ პაროლი"}
                                                            className={`popup-input-registration ${
                                                                formik.touched.ConfirmPassword &&
                                                                formik.errors.ConfirmPassword
                                                                    ? "input-error"
                                                                    : ""
                                                            }`}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.ConfirmPassword}
                                                            autoComplete="new-password"
                                                        />
                                                        <button
                                                            type="button"
                                                            onClick={() =>
                                                                setConfirmPasswordVisible(!confirmPasswordVisible)
                                                            }
                                                            className="toggle-password-visibility-reg"
                                                        >
                                                            {confirmPasswordVisible ? (
                                                                <AiFillEyeInvisible
                                                                    style={{fontSize: "20px", color: "black"}}
                                                                />
                                                            ) : (
                                                                <AiFillEye
                                                                    style={{fontSize: "20px", color: "black"}}
                                                                />
                                                            )}
                                                        </button>
                                                        {formik.touched.ConfirmPassword &&
                                                            formik.errors.ConfirmPassword && (
                                                                <div className="error-message-reg">
                                                                    {formik.errors.ConfirmPassword}
                                                                </div>
                                                            )}
                                                    </div>

                                                    {isUserVerified && userFirstName && (
                                                        <div style={{cursor: "not-allowed"}}>
                                                            <Tooltip title={orgFirstName}>
                                                                <div className="input-container">
                                                                    <input
                                                                        type="text"
                                                                        name="userFirstName"
                                                                        placeholder="სახელი"
                                                                        value={userFirstName}
                                                                        readOnly
                                                                        className="popup-input-registration-disabled"
                                                                    />
                                                                </div>
                                                            </Tooltip>
                                                        </div>
                                                    )}
                                                    {isUserVerified && userSurname && (
                                                        <div style={{cursor: "not-allowed"}}>
                                                            <Tooltip title={userSurname}>
                                                                <div className="input-container">
                                                                    <input
                                                                        type="text"
                                                                        name="userSurname"
                                                                        placeholder="გვარი"
                                                                        value={userSurname}
                                                                        readOnly
                                                                        className="popup-input-registration-disabled"
                                                                    />
                                                                </div>
                                                            </Tooltip>
                                                        </div>
                                                    )}


                                                    <div className="input-container">
                                                        <input
                                                            type="text"
                                                            name="Phone"
                                                            placeholder={"ტელეფონი (მობილური / სახლის)"}
                                                            className={`popup-input-registration ${
                                                                formik.touched.Phone && formik.errors.Phone
                                                                    ? "input-error"
                                                                    : ""
                                                            }`}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.Phone}
                                                        />
                                                        {formik.touched.Phone && formik.errors.Phone && (
                                                            <div className="error-message-reg">
                                                                {formik.errors.Phone}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="input-container">
                                                        <DatePicker
                                                            locale={ka}
                                                            selected={formik.values.birthDate}
                                                            onChange={date => formik.setFieldValue('birthDate', date)}
                                                            peekNextMonth
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            dateFormat="dd/MM/yyyy"
                                                            placeholderText="დაბადების თარიღი"
                                                            className={'popup-input-registration-datepicker'}
                                                        />
                                                        {formik.touched.birthDate && formik.errors.birthDate && (
                                                            <div className="error-message-reg">
                                                                {formik.errors.birthDate}
                                                            </div>
                                                        )}

                                                    </div>


                                                    <div>
                                                        <div className="checkbox-button-container">
                                                            <Checkbox
                                                                name="termsAccepted"
                                                                checked={formik.values.termsAccepted}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                color="primary"
                                                            />
                                                            <label
                                                                className={"agree-text"}
                                                                htmlFor="termsAccepted"
                                                            >
                                                                &nbsp;ვეთანხმები პირობებს
                                                                <div>
                                                                    <div
                                                                        className="open-condition-popup-button"
                                                                        onClick={toggleConditionPopup}
                                                                    >
                                                                        პირობების ნახვა
                                                                    </div>
                                                                </div>
                                                            </label>
                                                            {formik.touched.termsAccepted &&
                                                                formik.errors.termsAccepted && (
                                                                    <div className="error-message-reg">
                                                                        {formik.errors.termsAccepted}
                                                                    </div>
                                                                )}
                                                        </div>
                                                        {formik.touched.termsAccepted &&
                                                            formik.errors.termsAccepted && (
                                                                <div className="error-message-reg">
                                                                    {formik.errors.termsAccepted}
                                                                </div>
                                                            )}

                                                    </div>
                                                </div>
                                                <div>
                                                    <button className={"reg-button-popup"} type="submit">
                                                        რეგისტრაცია
                                                    </button>
                                                </div>
                                            </form>)}


                                        {isConditionPopupOpen && (
                                            <ConditionPopup
                                                title={"წესები და პირობები"}
                                                onClose={toggleConditionPopup}
                                            />
                                        )}
                                        {!isUserDataLoading && (
                                            <div style={{marginTop: !isMobile ? 166 : 0}} className="popup-bottom-text">
                                                <button
                                                    className="legal-back-button"
                                                    onClick={handleLoginClick}
                                                >
                                                    <IoArrowBack style={{marginRight: "8px"}}/> უკან
                                                    დაბრუნება
                                                </button>
                                            </div>
                                        )}

                                    </div>
                                </div>
                            ) : isLegalEntity && !canOrgRegister ? (
                                <div className="popup-legal">
                                    <AiOutlineClose
                                        className="popup-exit-icon"
                                        onClick={handleClose}
                                    />

                                    <div>
                                        <img src={herb} alt="Logo" className="popup-logo"/>
                                        <h1 className="popup-title">{"რეგისტრაცია"}</h1>
                                        <p className="popup-subtitle">
                                            {"სააგენტოს ციფრული პორტალი"}
                                        </p>
                                        <div className={"popup-login-switcher"}>
                                            <button
                                                className={`popup-text-blockk ${
                                                    !isLegalEntity ? "active" : ""
                                                }`}
                                                onClick={handlePrivateEntity}
                                            >
                                                {"ფიზიკური პირი"}
                                            </button>
                                            <button
                                                className={`popup-text-blockk ${
                                                    isLegalEntity ? "active" : ""
                                                }`}
                                                onClick={handleLegalEntity}
                                            >
                                                {"იურიდიული პირი"}
                                            </button>
                                        </div>
                                        {loadingOrgData ? (
                                            <div>
                                                <div style={{
                                                    textAlign: 'center',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    marginTop: "20%"
                                                }}>

                                                    <MdOutlineVerified style={{fontSize: 80, color: 'black'}}
                                                                       className={"pulse-element"}/>
                                                    <h1>გთხოვთ დაელოდოთ...</h1>
                                                    <p>მიმდინარეობს მონაცემების ვერიფიკაცია!</p>
                                                </div>
                                            </div>
                                        ) : (
                                            <div style={{margin: "20px"}}>
                                                <input
                                                    placeholder={"ორგანიზაციის საიდენთიფიკაციო კოდი"}
                                                    value={orgNumber}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (/^\d*$/.test(value)) {
                                                            setOrgNumber(value);
                                                        }
                                                    }}
                                                    className={"popup-input-animation"}

                                                />

                                                <div className={"error-text-animation"}>
                                                    {
                                                        orgNumber !== "" && (orgNumber.length !== 9 && orgNumber.length !== 11)
                                                            ? "საიდენტიფიკაციო კოდი უნდა შეიცავდეს 9 ან 11 სიმბოლოს!"
                                                            : ""

                                                    }
                                                </div>



                                                <Tooltip
                                                    title={
                                                        orgNumber === ""
                                                            ? "გთხოვთ შეიყვანოთ საიდენთიფიკაციო კოდი!"
                                                            : (orgNumber.length !== 9 || orgNumber.length !== 11)
                                                                ? "ორგანიზაციის საიდენტიფიკაციო კოდი უნდა შეიცავდეს 9 ან 11 სიმბოლოს!"
                                                                : ""
                                                    }
                                                >
                                                <span>
                                                    <Button
                                                        onClick={() => verifyOrgNumber(orgNumber)}
                                                        disabled={
                                                            orgNumber === "" ||
                                                            (orgNumber.length !== 9 && orgNumber.length !== 11)

                                                        }
                                                        variant="contained"
                                                        color="primary"
                                                        className={"slide-in-input"}
                                                        endIcon={<MdCheckCircle/>}
                                                        style={{textTransform: "none"}}
                                                    >
                                                        ვერიფიკაცია
                                                    </Button>
                                                </span>
                                                </Tooltip>
                                                <div style={{marginTop: !isMobile ? 90 : 0}}
                                                     className="popup-bottom-text">
                                                    <button
                                                        className="legal-back-button"
                                                        onClick={handleLoginClick}
                                                    >
                                                        <IoArrowBack style={{marginRight: "8px"}}/> უკან
                                                        დაბრუნება
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ) : (
                                <div className="popup-forget-legal-registration">
                                    <AiOutlineClose
                                        className="popup-exit-icon"
                                        onClick={handleClose}
                                    />
                                    <div>
                                        <img src={herb} alt="Logo" className="popup-logo"/>
                                        <h1 className="popup-title">{"რეგისტრაცია"}</h1>
                                        <p className="popup-subtitle">
                                            {"სააგენტოს ციფრული პორტალი"}
                                        </p>
                                        <div className={"popup-login-switcher"}>
                                            <button
                                                className={`popup-text-blockk ${
                                                    !isLegalEntity ? "active" : ""
                                                }`}
                                                onClick={handlePrivateEntity}
                                            >
                                                {"ფიზიკური პირი"}
                                            </button>
                                            <button
                                                className={`popup-text-blockk ${
                                                    isLegalEntity ? "active" : ""
                                                }`}
                                                onClick={handleLegalEntity}
                                            >
                                                {"იურიდიული პირი"}
                                            </button>
                                        </div>
                                        <form autoComplete="off" onSubmit={formik.handleSubmit}>
                                            <button
                                                className="legal-back-button"
                                                onClick={handleBackLegal}
                                            >
                                                <IoArrowBack style={{marginRight: "8px"}}/> უკან
                                                დაბრუნება
                                            </button>
                                            <div className={"popup-registrtation-form"}>
                                                {isLegalEntity && orgNumber && (
                                                    <div style={{cursor: "not-allowed"}}>
                                                        <Tooltip title={orgNumber}>
                                                            <div className="input-container">
                                                                <input
                                                                    type="text"
                                                                    name="orgNumber"
                                                                    placeholder="ორგანიზაციის საიდენტიფიკაციო კოდი"
                                                                    value={orgNumber}
                                                                    readOnly
                                                                    className="popup-input-registration-disabled"
                                                                />
                                                            </div>
                                                        </Tooltip>
                                                    </div>
                                                )}
                                                {isLegalEntity && orgName && (
                                                    <div style={{cursor: "not-allowed"}}>
                                                        <Tooltip title={orgName}>
                                                            <div className="input-container">
                                                                <input
                                                                    type="text"
                                                                    name="orgName"
                                                                    placeholder="ორგანიზაციის საიდენტიფიკაციო კოდი"
                                                                    value={orgName}
                                                                    readOnly
                                                                    className="popup-input-registration-disabled"
                                                                />
                                                            </div>
                                                        </Tooltip>
                                                    </div>
                                                )}
                                                <div className="input-container">
                                                    <input
                                                        type="email"
                                                        name="Email"
                                                        placeholder={"ელ-ფოსტა"}
                                                        className={`popup-input-registration ${
                                                            formik.touched.Email && formik.errors.Email ? "input-error" : ""
                                                        }`}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.Email}
                                                        autoComplete="off"
                                                    />
                                                    {formik.touched.Email && formik.errors.Email && (
                                                        <div className="error-message-reg">
                                                            {formik.errors.Email}
                                                        </div>
                                                    )}
                                                </div>

                                                {isOrgVerified && orgPrivateNumber && (
                                                    <div style={{cursor: "not-allowed"}}>
                                                        <Tooltip title={orgPrivateNumber}>
                                                            <div className="input-container">
                                                                <input
                                                                    type="text"
                                                                    name="orgPrivateNumber"
                                                                    placeholder="პირადი ნომერი"
                                                                    value={orgPrivateNumber}
                                                                    readOnly
                                                                    className="popup-input-registration-disabled"
                                                                />
                                                            </div>
                                                        </Tooltip>
                                                    </div>
                                                )}

                                                <div className="input-container">
                                                    <input
                                                        type={passwordVisibleReg ? "text" : "password"}
                                                        name="Password"
                                                        placeholder="პაროლი"
                                                        className={`popup-input-registration ${
                                                            formik.touched.Password && formik.errors.Password ? "input-error" : ""
                                                        }`}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.Password}
                                                        autoComplete="new-password"
                                                    />
                                                    <button
                                                        type="button"
                                                        onClick={() =>
                                                            setPasswordVisibleReg(!passwordVisibleReg)
                                                        }
                                                        className="toggle-password-visibility-reg"
                                                    >
                                                        {passwordVisibleReg ? (
                                                            <AiFillEyeInvisible
                                                                style={{fontSize: "20px", color: "black"}}
                                                            />
                                                        ) : (
                                                            <AiFillEye
                                                                style={{fontSize: "20px", color: "black"}}
                                                            />
                                                        )}
                                                    </button>
                                                    {formik.touched.Password && formik.errors.Password && (
                                                        <div className="error-message-reg">
                                                            {formik.errors.Password}
                                                        </div>
                                                    )}
                                                </div>

                                                <div className="input-container">
                                                    <input
                                                        type={confirmPasswordVisible ? "text" : "password"}
                                                        name="ConfirmPassword"
                                                        placeholder={"გაიმეორეთ პაროლი"}
                                                        className={`popup-input-registration ${
                                                            formik.touched.ConfirmPassword &&
                                                            formik.errors.ConfirmPassword
                                                                ? "input-error"
                                                                : ""
                                                        }`}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.ConfirmPassword}
                                                        autoComplete="new-password"
                                                    />
                                                    <button
                                                        type="button"
                                                        onClick={() =>
                                                            setConfirmPasswordVisible(!confirmPasswordVisible)
                                                        }
                                                        className="toggle-password-visibility-reg"
                                                    >
                                                        {confirmPasswordVisible ? (
                                                            <AiFillEyeInvisible
                                                                style={{fontSize: "20px", color: "black"}}
                                                            />
                                                        ) : (
                                                            <AiFillEye
                                                                style={{fontSize: "20px", color: "black"}}
                                                            />
                                                        )}
                                                    </button>
                                                    {formik.touched.ConfirmPassword &&
                                                        formik.errors.ConfirmPassword && (
                                                            <div className="error-message-reg">
                                                                {formik.errors.ConfirmPassword}
                                                            </div>
                                                        )}
                                                </div>

                                                {isLegalEntity && orgFirstName && (
                                                    <div style={{cursor: "not-allowed"}}>
                                                        <Tooltip title={orgFirstName}>
                                                            <div className="input-container">
                                                                <input
                                                                    type="text"
                                                                    name="orgFirstName"
                                                                    placeholder="სახელი"
                                                                    value={orgFirstName}
                                                                    readOnly
                                                                    className="popup-input-registration-disabled"
                                                                />
                                                            </div>
                                                        </Tooltip>
                                                    </div>
                                                )}

                                                {isOrgVerified && orgSurname && (
                                                    <div style={{cursor: "not-allowed"}}>
                                                        <Tooltip title={orgSurname}>
                                                            <div className="input-container">
                                                                <input
                                                                    type="text"
                                                                    name="orgSurname"
                                                                    placeholder="გვარი"
                                                                    value={orgSurname}
                                                                    readOnly
                                                                    className="popup-input-registration-disabled"
                                                                />
                                                            </div>
                                                        </Tooltip>
                                                    </div>
                                                )}

                                                <div className="input-container">
                                                    <input
                                                        type="text"
                                                        name="Phone"
                                                        placeholder={"ტელეფონი (მობილური / სახლის)"}
                                                        className={`popup-input-registration ${
                                                            formik.touched.Phone && formik.errors.Phone
                                                                ? "input-error"
                                                                : ""
                                                        }`}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.Phone}
                                                    />
                                                    {formik.touched.Phone && formik.errors.Phone && (
                                                        <div className="error-message-reg">
                                                            {formik.errors.Phone}
                                                        </div>
                                                    )}
                                                </div>


                                                <div className="checkbox-button-container">
                                                    <div className="input-container">
                                                        <Checkbox
                                                            name="termsAccepted"
                                                            checked={formik.values.termsAccepted}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            color="primary"
                                                        />
                                                        <label
                                                            className={"agree-text"}
                                                            htmlFor="termsAccepted"
                                                        >
                                                            ვეთანხმები პირობებს

                                                        </label>
                                                        {formik.touched.termsAccepted &&
                                                            formik.errors.termsAccepted && (
                                                                <div className="error-message-reg">
                                                                    {formik.errors.termsAccepted}
                                                                </div>
                                                            )}
                                                    </div>
                                                    {formik.touched.termsAccepted &&
                                                        formik.errors.termsAccepted && (
                                                            <div className="error-message-reg">
                                                                {formik.errors.termsAccepted}
                                                            </div>
                                                        )}

                                                </div>
                                            </div>
                                            <div>
                                                <button className={"reg-button-popup"} type="submit">
                                                    რეგისტრაცია
                                                </button>
                                            </div>
                                        </form>

                                        {isConditionPopupOpen && (
                                            <ConditionPopup
                                                title={"წესები და პირობები"}
                                                onClose={toggleConditionPopup}
                                            />
                                        )}
                                        <div className="popup-bottom-text">
                                            <button
                                                className="legal-back-button"
                                                onClick={handleLoginClick}
                                            >
                                                <IoArrowBack style={{marginRight: "8px"}}/> უკან
                                                დაბრუნება
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                    </div>
                )}

                {showForgotPassword && (
                    <div className={`popup-container`}>
                        <div className="popup-forgett">
                            <AiOutlineClose
                                className="popup-exit-icon"
                                onClick={handleClose}
                            />
                            <div>
                                <img src={herb} alt="Logo" className="popup-logo"/>
                                <h1 className="popup-title">{"დაგავიწყდა პაროლი?"}</h1>

                                <p className="popup-subtitle">{"სააგენტოს ციფრული პორტალი"}</p>
                                <input
                                    type="text"
                                    className="popup-input"
                                    placeholder={"ელ.ფოსტა"}
                                    value={forgotEmail}
                                    onChange={(e) => setForgotEmail(e.target.value)}
                                />

                                {forgotEmailError && (
                                    <div className="error-message-reg-forget-password">
                                        {forgotEmailError}
                                    </div>
                                )}
                                {forgotEmailSuccess && (
                                    <div className="forget-message-success">
                                        <AiOutlineCheckCircle className="success-icon"/>
                                        პაროლის აღდგენის ინსტრუქცია გამოგზავნილია თქვენს ელ-ფოსტაზე!
                                    </div>
                                )}
                                <Tooltip title={!forgotEmail ? "შეიყვანეთ პაროლი" : ""}>
                                    <div>
                                        <button
                                            className="popup-login-button"
                                            onClick={handleForgotPasswordSubmit}
                                            disabled={!forgotEmail}
                                        >
                                            {"პაროლის აღდგენა"}
                                        </button>
                                    </div>
                                </Tooltip>

                                <div className="popup-bottom-text">
                                    <button
                                        className="legal-back-button"
                                        onClick={handleLoginClick}
                                    >
                                        <IoArrowBack style={{marginRight: "8px"}}/> უკან
                                        დაბრუნება
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {alert.show && (
                    <CustomAlert
                        message={alert.message}
                        type={alert.type}
                        onClose={() => setAlert({...alert, show: false})}
                    />
                )}
            </div>
        )
    );
};

export default PopupLogin;
